<template>
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5 15.5h-6a6 6 0 00-6 6v1s3.125 1 9 1 9-1 9-1v-1a6 6 0 00-6-6zM7.5 6.5a5 5 0 0110 0c0 2.761-2.239 6-5 6s-5-3.239-5-6z"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="square"
    />
  </svg>
</template>
